angular.
module("dx.webapp.masterTools").
controller("DxStudentBulkDeleteRouteController", function studentBulkDeleteRouteController(
	$http,
	$scope,

	validationService,
	dxApiV1Students,
	dxDialog,
	NodeRepository,
	Node,
	DxJob,

	ngPasteFromErrors
) {
	"use strict";

	var self = this;

	var numberOfRows;
	var rowValidationCounter;
	var ids;
	var emails;

	self.nodes = [];
	self.selectedOrganization = null;

	init();

	function init() {
		self.students = [];
		self.errors = [];
		self.loading = false;
		self.jobs = [];

		ids = [];
		emails = [];

		numberOfRows = 0;
		rowValidationCounter = 0;
	}

	NodeRepository.list().then(function success(response) {
		self.nodes = response.nodes.map(function mapNodes(nodeData) {
			return new Node(nodeData);
		});
	});

	self.onBeforePaste = function onBeforePaste(data) {
		init();
		numberOfRows = data.split(/\r\n|\r|\n/).length;
		return data;
	};

	self.onValidateEntry = function onValidateEntry(row) {
		var emailOrId = row.emailOrId.trim();
		var isValid = !isDuplicate(emailOrId);

		if (isNumber(emailOrId)) {
			ids.push(emailOrId);
		} else if (isEmail(emailOrId)) {
			emails.push(emailOrId);
		} else {
			self.errors.push("Not a valid e-mail or user id: " + emailOrId);
			isValid = false;
		}

		rowValidationCounter++;
		if (rowValidationCounter === numberOfRows) {
			getStudents();
		}

		return isValid;
	};

	self.onEntryError = function onEntryError(error, rowData) {
		if (error === ngPasteFromErrors.invalidColumnLength) {
			var expectedColumns = rowData.expectedLength + " column" + (rowData.expectedLength > 1 ? "s" : "");
			return self.errors.push("Expected row " + (rowData.index + 1) + " to be " + expectedColumns + ", but it was " + rowData.actualLength + ": " + rowData.source);
		}

		return null;
	};

	self.confirmDelete = function confirmDelete() {
		dxDialog.confirm({
			title: "Delete students",
			body: "WARNING: The operation permanently redacts students and is irreversible. Are you sure you want to GDPR-delete these students?",
			acceptText: "Delete",
			acceptCallback: bulkDeleteStudents,
			rejectText: "Cancel",
		});
	};

	$scope.$watch("vm.selectedOrganization", function onSelectedOrganizationChange() {
		// Reset
		init();
	});

	function bulkDeleteStudents() {
		self.errors = [];

		var studentIds = self.students.map(function mapStudents(student) {
			return student.id;
		}).filter(function unique(studentId, index, array) {
			return array.indexOf(studentId) === index;
		});

		dxDialog.closeMostRecent();
		self.loading = true;

		return $http.delete("/api/v1/gdpr/delete/students", {
			params: {
				organizationId: self.selectedOrganization.id,
				studentIds: studentIds,
			}}).
			then(function success(resp) {
				self.jobs = resp.data.map(function mapFn(jobData) {
					return new DxJob(jobData);
				});
			}, function fail(resp) {
				self.errors.push("Could not perform the GDPR-delete request: " + resp.data.message);
			}).
			finally(function done() {
				self.loading = false;
				self.students = [];
				ids = [];
				emails = [];
				numberOfRows = 0;
				rowValidationCounter = 0;
			});
	}

	function getStudents() {
		self.loading = emails.length || ids.length;
		if (!self.selectedOrganization) {
			return;
		}

		dxApiV1Students.get({
			organizationId: self.selectedOrganization.id,
			studentIds: ids,
			emails: emails,
		}).then(function success(response) {
			self.students = response.data;
		}, function fail(response) {
			self.errors.push(response.data.message);
		}).finally(function done() {
			self.loading = false;
		});
	}

	function isDuplicate(emailOrId) {
		return ids.includes(emailOrId) || emails.includes(emailOrId);
	}

	function isNumber(numStr) {
		return !isNaN(numStr) && !isNaN(parseFloat(numStr));
	}

	function isEmail(string) {
		return validationService.isEmailValid(string.trim());
	}
});
